interface Props {
  children: React.ReactNode;
  colorSwap?: boolean;
  disabled?: boolean;
  fit?: boolean;
  onClick?: () => void;
  red?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

export default function MonsterButton({ children, colorSwap, fit, onClick, red, type = 'submit', disabled }: Props) {
  if (colorSwap) {
    return (
      <button
        disabled={disabled}
        onClick={onClick}
        type={type}
        className={`bg-monsterPurple hover:bg-monsterPurpleHover ${fit ? 'w-fit' : 'w-full'} border-siteBackground nice-hover-burnout cursor-pointer rounded-lg border-2 px-3 py-2 text-center font-bold text-white transition-all duration-200 ease-in-out`}
      >
        {children}
      </button>
    );
  }

  if (red) {
    return (
      <button
        disabled={disabled}
        onClick={onClick}
        type={type}
        className={`${fit ? 'w-fit' : 'w-full'} border-siteBackground nice-hover-burnout cursor-pointer rounded-lg border-2 bg-red-600 px-3 py-2 text-center font-bold text-white transition-all duration-200 ease-in-out hover:bg-red-800`}
      >
        {children}
      </button>
    );
  }

  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`bg-monsterGreen hover:bg-monsterGreenHover border-siteBackground text-siteBackground nice-hover-burnout border-2 ${fit ? 'w-fit' : 'w-full'} cursor-pointer rounded-lg px-3 py-2 text-center font-bold transition-all duration-200 ease-in-out`}
    >
      {children}
    </button>
  );
}
